<style>
.list-group-item2 {
    position: relative;
    /* display: block; */
    padding: var(--bs-list-group-item-padding-y) var(--bs-list-group-item-padding-x);
    color: var(--bs-list-group-color);
    text-decoration: none;
    background-color: var(--bs-list-group-bg);
    border: var(--bs-list-group-border-width) solid var(--bs-list-group-border-color);
}
</style>
<template>
    <div class="app-layout">
        <!-- Componente de la barra de navegación -->
        <NavBar :collapsed="collapsed" :pinned="pinned" @update:collapsed="updateCollapsed"
            @update:pinned="updatePinned" />
        <!-- Contenido principal -->

        <main :class="{ 'main-collapsed': collapsed, 'main-expanded': !collapsed || pinned }">
            <BarTop />
            <div class="pt-2 px-3">
                <div class="py-4">
                    <h2 class="">Notas de cobro</h2>
                    <p>Listar todas las notas de cobro.</p>
                    <div class="text-end">
                        <a class="btn btn-success" href="notascobro/crear">Agregar nota de cobro</a>
                    </div>
                </div>
                <p>Filtros</p>
                <div class="m-3 row">
                    <div class="col-md-2 mb-4">
                        <label for="rut" class="form-label">RUT cliente</label>
                        <input type="text" class="form-control" :class="{ 'border-danger': dataForm.rut.err }" id="rut"
                            placeholder="Use solo números y guión" @input="handleRutInput" v-model="dataForm.rut.value">
                        <span v-if="dataForm.rut.err" class="text-danger">Debe ingresar un
                            RUT</span>
                    </div>
                    <div class="col-md-2 mb-4">
                        <label for="name" class="form-label">Nombre cliente</label>
                        <input type="text" class="form-control" :class="{ 'border-danger': dataForm.name.err }"
                            id="name" placeholder="" v-model="dataForm.name.value">
                        <span v-if="dataForm.name.err" class="text-danger">Debe ingresar un
                            nombre</span>
                    </div>
                    <div class="col-md-3 mb-4">
                        <label for="billing_note_number" class="form-label">Nº nota de cobro</label>
                        <input type="text" class="form-control"
                            :class="{ 'border-danger': dataForm.billing_note_number.err }" id="billing_note_number"
                            placeholder="" v-model="dataForm.billing_note_number.value">
                        <span v-if="dataForm.billing_note_number.err" class="text-danger">Debe ingresar un
                            número de nota de cobro</span>
                    </div>

                    <div class="col-md-2 mb-4">
                        <label for="amount" class="form-label">Monto</label>
                        <input type="text" class="form-control" :class="{ 'border-danger': dataForm.amount.err }"
                            id="amount" placeholder="" v-model="dataForm.amount.value">
                        <span v-if="dataForm.amount.err" class="text-danger">Debe ingresar un monto</span>
                    </div>
                    <div class="col-md-2 mt-4">
                        <div class="text-end">
                            <span class="mx-1">
                                <a class="btn btn-success" @click="filter()">Filtrar</a>
                            </span>
                            <a class="btn btn-success" @click="deleteFilters()">Limpiar filtros</a>
                        </div>
                    </div>
                </div>
                <div>
                    <vue3-datatable :no-data-content="'No se encontraron resultados.'" :search="search" :rows="items"
                        :columns="columns" order :sortable="true" :sort-column="sortColumn"
                        :sort-direction="sortDirection" :is-server-mode="true" :page="page" :page-size="perPage"
                        :total-rows="totalRows" :loading="loading" @change="onTableChange">
                        <!-- tus slots existentes permanecen igual -->
                        <template #is_emit="data">
                            <span v-if="data.value.is_emit == 1">SÍ</span>
                            <span v-else>No</span>
                        </template>

                        <template #emit_amount="data">
                            <span>{{ data.value.emit_amount > 0 ? formatCurrency(data.value.emit_amount,
            data.value.initials) : 0 }}</span>
                        </template>

                        <template #saldo="data">
                            <span>{{ data.value.saldo > 0 ? formatCurrency(data.value.saldo, data.value.initials) : 0
                                }}</span>
                        </template>

                        <template #rut="row">
                            <td style=" text-align: end; white-space: nowrap;">{{ row.value.rut }}</td>
                        </template>
                        <template #emit_date="row">
                            <td style=" text-align: end; white-space: nowrap;">{{ row.value.emit_date }}</td>
                        </template>
                        <template #created_at="row">
                            <td style=" text-align: end; white-space: nowrap;">{{ row.value.created_at }}</td>
                        </template>
                        <template #actions="data">
                            <!-- ... (sin cambios) ... -->
                        </template>
                    </vue3-datatable>
                </div>
            </div>
        </main>
        <!-- Emitir -->
        <div class="modal-mb" v-if="emitirModal">
            <div class="modal-dialo bg-white">
                <div class="modal-content">
                    <div class="modal-header row">
                        <h5 class="modal-title text-black col-11">Emitir boleta</h5>
                        <button type="button" class="btn-close col" @click="closeEmitModal()"
                            aria-label="Close"></button>
                    </div>

                    <div class="modal-body mt-2">
                        <div class="card p-4">
                            <div class="row">
                                <div class="col-md-4">
                                    <b>ID Nota de cobro</b>
                                    <p>{{ emitNote?.id_billing_note }}</p>
                                </div>
                                <div class="col-md-4">
                                    <b>Nº nota de cobro</b>
                                    <p>{{ emitNote?.billing_note_number }}</p>
                                </div>
                            </div>

                            <div class="row pt-4 px-1">
                                <div class="col-12 col-md-4 mb-4">
                                    <label for="date_emit" class="form-label">
                                        Fecha de emisión
                                    </label>
                                    <div class="input-group mb-1">
                                        <VueDatePicker v-model="date_emit.value" locale="es" :enable-time-picker="false"
                                            format="dd/MM/yyyy" cancel-text="Cancelar" select-text="Seleccionar"
                                            :teleport="true" />
                                    </div>
                                    <span v-if="date_emit.err" class="text-danger">Debe escoger una
                                        fecha</span>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="modal-footer mt-3">
                        <button type="button" class="btn btn-secondary mx-2" @click="closeEmitModal()">Cancelar</button>
                        <button type="button" class="btn btn-success" @click="confirmEmit()">Emitir</button>
                    </div>
                </div>
            </div>
        </div>
        <!-- Abonar DESDE PROVISIÓN -->
        <div class="modal-mb" v-if="abonarProvisionModal">
            <div class="modal-dialo bg-white">
                <div class="modal-content">
                    <div class="modal-header row">
                        <h5 class="modal-title text-black col-11">Abonar desde provisión</h5>
                        <button type="button" class="btn-close col" @click="closeAbonarProvisionModal()"
                            aria-label="Close"></button>
                    </div>

                    <div class="modal-body mt-2" style="height:70vh;overflow-y:auto;">
                        <div class="card p-4">
                            <div class="row">
                                <div class="col-md-4">
                                    <b>ID Nota de cobro</b>
                                    <p>{{ abonarNote?.id_billing_note }}</p>
                                </div>
                                <div class="col-md-4">
                                    <b>Nº nota de cobro</b>
                                    <p>{{ abonarNote?.billing_note_number }}</p>
                                </div>
                                <div class="col-md-4">
                                    <b>Cliente</b>
                                    <p>{{ abonarNote?.name }}</p>
                                </div>
                            </div>

                            <div class="row">
                                <div class="col-md-4">
                                    <b>Monto impago total</b>
                                    <p>
                                        {{ (abonarNote?.saldo || 0) > 0 ? formatCurrency(abonarNote.saldo,
            abonarNote?.initials)
            : 0 }}
                                    </p>
                                </div>
                            </div>

                            <hr class="my-3" />

                            <p>Provisiones asociadas al cliente <b>{{ clientName }}</b></p>

                            <vue3-datatable :search="search" :rows="supply" :columns="supplyColumns" order
                                :sortable="true" :sortColumn="'date'">
                                <template #actions="data">
                                    <button @click="toggleSelectionSupply(data.value)">
                                        {{ isSelectedSupp(data.value) ? 'Desasociar' : 'Asociar' }}
                                    </button>
                                </template>

                                <template #item="data">
                                    <span>{{ transformItem(data.value.client_supply_concept) }}</span>
                                </template>

                                <template #amount="data">
                                    <span>
                                        {{ data.value.remaining > 0 ? formatCurrency(data.value.remaining,
            data.value.currency?.initials || 'CLP') : 0 }}
                                    </span>
                                </template>
                            </vue3-datatable>
                            <!-- === PAGOS ASOCIADOS (igual que en abono normal) === -->
                            <div class="row mt-4">
                                <div class="col-12">
                                    <div class="d-flex justify-content-between align-items-center">
                                        <b>Pagos asociados</b>
                                        <div class="form-check">
                                            <input class="form-check-input" type="checkbox" :checked="allAbonarSelected"
                                                @change="toggleSelectAllAbonar" id="chkAllAbonarProv">
                                            <label class="form-check-label" for="chkAllAbonarProv">Seleccionar
                                                todos</label>
                                        </div>
                                    </div>

                                    <div class="table-responsive mt-2">
                                        <table class="table table-sm align-middle">
                                            <thead>
                                                <tr>
                                                    <th class="text-center">Sel.</th>
                                                    <th>ID</th>
                                                    <th>Concepto</th>
                                                    <th class="text-end">Monto</th>
                                                    <th class="text-end">Impago</th>
                                                    <th>Moneda</th>
                                                    <th style="width:200px" class="text-end">Monto a abonar</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr v-if="!abonarNote?.pagos || abonarNote?.pagos?.length === 0">
                                                    <td colspan="7" class="text-center">Sin pagos disponibles</td>
                                                </tr>
                                                <tr v-for="p in abonarNote?.pagos" :key="p.id_payment">
                                                    <td class="text-center">
                                                        <input type="checkbox"
                                                            :checked="isPaymentSelected(p.id_payment)"
                                                            @change="toggleSelectPayment(p)">
                                                    </td>
                                                    <td>{{ p.id_payment }}</td>
                                                    <td>{{ p.concept }}</td>
                                                    <td class="text-end">
                                                        {{ p.amount > 0 ? formatCurrency(p.amount, p.initials) : 0 }}
                                                    </td>
                                                    <td class="text-end">
                                                        {{ p.unpaid_amount > 0 ? formatCurrency(p.unpaid_amount,
            p.initials) : 0
                                                        }}
                                                    </td>
                                                    <td>{{ p.initials }}</td>

                                                    <!-- Monto por pago solo si está seleccionado y NO es “seleccionar todos” -->
                                                    <td class="text-end">
                                                        <input
                                                            v-if="isPaymentSelected(p.id_payment) && !allAbonarSelected"
                                                            type="number" min="0" step="0.01"
                                                            class="form-control text-end" :placeholder="'0.00'"
                                                            v-model.number="selectedAmounts[p.id_payment]" />
                                                        <div v-if="amountErrors[p.id_payment]"
                                                            class="text-danger small mt-1">
                                                            {{ amountErrors[p.id_payment] }}
                                                        </div>
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>

                                    <!-- Monto global si TODOS están seleccionados -->
                                    <div class="row mt-2" v-if="allAbonarSelected">
                                        <div class="col-md-4 ms-auto">
                                            <label class="form-label">Monto global a abonar</label>
                                            <input type="number" min="0" step="0.01" class="form-control text-end"
                                                v-model.number="globalAmount.value" placeholder="0.00" />
                                            <div v-if="globalError" class="text-danger small mt-1">
                                                {{ globalError }}
                                            </div>
                                        </div>
                                    </div>

                                    <small class="text-muted">
                                        Seleccionados: {{ selectedPayments.length }}.
                                        <span v-if="allAbonarSelected">Se utilizará el monto global.</span>
                                        <span v-else-if="selectedPayments.length > 0">Asigna el monto en cada fila
                                            seleccionada.</span>
                                    </small>
                                </div>
                            </div>

                            <hr class="my-4" />
                            <div class="mt-3 text-muted small" v-if="!selectedSupply">
                                Selecciona una provisión para continuar.
                            </div>
                            <div class="mt-2" v-else>
                                <span class="badge bg-primary">
                                    Provisión seleccionada #{{ selectedSupply?.id_clients_supply }}
                                </span>
                            </div>

                            <hr class="my-4" />

                            <!-- Fecha, divisa, TC, monto global -->
                            <div class="row">
                                <div class="col-12 col-md-4 mb-3">
                                    <label class="form-label">Fecha del pago</label>
                                    <VueDatePicker v-model="dataForm2.abonoDate.value" locale="es"
                                        :enable-time-picker="false" format="dd/MM/yyyy" cancel-text="Cancelar"
                                        select-text="Seleccionar" :teleport="true" />
                                    <span v-if="dataForm2.abonoDate.err" class="text-danger">Debe escoger una
                                        fecha</span>
                                </div>

                                <div class="col-12 col-md-4 mb-3">
                                    <label class="form-label">Divisa</label>
                                    <select class="form-select" v-model="dataForm2.currenci.value" disabled>
                                        <option v-for="c in currencies" :key="c.id_currency" :value="c.id_currency">
                                            {{ c.name }}
                                        </option>
                                    </select>
                                </div>


                                <div class="row" v-if="dataForm2.currenci.value !== CLP_CURRENCY_ID">
                                    <p>En caso de abonar en moneda distinta a la del pago a proveedor original, llenar:
                                    </p>
                                    <div class="col-6 col-md-4 mb-3">
                                        <label class="form-label">Tasa de cambio</label>
                                        <input type="number" min="0" step="0.0001" class="form-control"
                                            v-model.number="dataForm2.exchangeRate.value" />
                                        <span v-if="dataForm2.exchangeRate.err" class="text-danger">Ingrese una tasa
                                            válida</span>
                                    </div>

                                    <div class="col-6 mb-4">
                                        <button class="btn btn-secondary dropdown-toggle" type="button"
                                            data-bs-toggle="dropdown" aria-expanded="false" @click="toggleDolarTabla()">
                                            Ver tasas de cambio (dólar)
                                        </button>
                                    </div>
                                </div>

                                <div class="row" v-if="showDolarTable">
                                    <div class="col-6 mb-4">
                                        <vue3-datatable :search="search" :rows="exchangeDollar" :columns="columns3"
                                            order :sortable="true">

                                            <template #year="data">
                                                <span>{{ data.value.year }}</span>
                                            </template>
                                            <template #month="data">
                                                <span>{{ data.value.month }}</span>
                                            </template>
                                            <template #dollar_value="data">
                                                <span>{{ data.value.dollar_value }}</span>
                                            </template>
                                        </vue3-datatable>
                                    </div>
                                </div>
                            </div>



                        </div>
                    </div>

                    <div class="modal-footer mt-3">
                        <button type="button" class="btn btn-secondary mx-2"
                            @click="closeAbonarProvisionModal()">Cancelar</button>
                        <button type="button" class="btn btn-success" @click="abonarDesdeProvision()"
                            :disabled="!canSubmitAbonoProvision">
                            Abonar desde provisión
                        </button>
                    </div>
                </div>
            </div>
        </div>
        <!-- Abonar -->
        <div class="modal-mb" v-if="abonarModal">
            <div class="modal-dialo bg-white">
                <div class="modal-content">
                    <div class="modal-header row">
                        <h5 class="modal-title text-black col-11">Abonar pagos</h5>
                        <button type="button" class="btn-close col" @click="closeAbonarModal()"
                            aria-label="Close"></button>
                    </div>

                    <div class="modal-body mt-2" style='height: 70vh;
    overflow-y: auto;'>
                        <div class="card p-4">
                            <!-- Encabezado -->
                            <div class="row">
                                <div class="col-md-4">
                                    <b>ID Nota de cobro</b>
                                    <p>{{ abonarNote?.id_billing_note }}</p>
                                </div>
                                <div class="col-md-4">
                                    <b>Nº nota de cobro</b>
                                    <p>{{ abonarNote?.billing_note_number }}</p>
                                </div>
                                <div class="col-md-4">
                                    <b>Cliente</b>
                                    <p>{{ abonarNote?.name }}</p>
                                </div>
                                <!-- Monto impago total (nuevo) -->
                                <div class="row">
                                    <div class="col-md-4">
                                        <b>Monto impago total</b>
                                        <p>
                                            {{ (abonarNote?.saldo || 0) > 0 ? formatCurrency(abonarNote.saldo,
            abonarNote?.initials) : 0 }}
                                        </p>
                                    </div>
                                </div>
                            </div>

                            <!-- Tabla de pagos con checkbox y monto por pago -->
                            <div class="row mt-3">
                                <div class="col-12">
                                    <div class="d-flex justify-content-between align-items-center">
                                        <b>Pagos asociados</b>
                                        <div class="form-check">
                                            <input class="form-check-input" type="checkbox" :checked="allAbonarSelected"
                                                @change="toggleSelectAllAbonar" id="chkAllAbonar">
                                            <label class="form-check-label" for="chkAllAbonar">Seleccionar todos</label>
                                        </div>
                                    </div>

                                    <div class="table-responsive mt-2">
                                        <table class="table table-sm align-middle">
                                            <thead>
                                                <tr>
                                                    <th class="text-center">Sel.</th>
                                                    <th>ID</th>
                                                    <th>Concepto</th>
                                                    <th class="text-end">Monto</th>
                                                    <th class="text-end">Impago</th>
                                                    <th>Moneda</th>
                                                    <th style="width:200px" class="text-end">Monto a abonar</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr v-if="!abonarNote?.pagos || abonarNote?.pagos?.length === 0">
                                                    <td colspan="7" class="text-center">Sin pagos disponibles</td>
                                                </tr>
                                                <tr v-for="p in abonarNote?.pagos" :key="p.id_payment">
                                                    <td class="text-center">
                                                        <input type="checkbox"
                                                            :checked="isPaymentSelected(p.id_payment)"
                                                            @change="toggleSelectPayment(p)">
                                                    </td>
                                                    <td>{{ p.id_payment }}</td>
                                                    <td>{{ p.concept }}</td>
                                                    <td class="text-end">
                                                        {{ p.amount > 0 ? formatCurrency(p.amount, p.initials) : 0 }}
                                                    </td>
                                                    <td class="text-end">
                                                        {{ p.unpaid_amount > 0 ? formatCurrency(p.unpaid_amount,
            p.initials) : 0
                                                        }}
                                                    </td>
                                                    <td>{{ p.initials }}</td>

                                                    <!-- Monto por pago: sólo se muestra si está seleccionado y NO está “seleccionar todos” -->
                                                    <td class="text-end">
                                                        <input
                                                            v-if="isPaymentSelected(p.id_payment) && !allAbonarSelected"
                                                            type="number" min="0" step="0.01"
                                                            class="form-control text-end" :placeholder="'0.00'"
                                                            v-model.number="selectedAmounts[p.id_payment]" />
                                                        <div v-if="amountErrors[p.id_payment]"
                                                            class="text-danger small mt-1">
                                                            {{ amountErrors[p.id_payment] }}
                                                        </div>
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>

                                    <!-- Monto global: si TODOS están seleccionados -->
                                    <div class="row mt-2" v-if="allAbonarSelected">
                                        <div class="col-md-4 ms-auto">
                                            <label class="form-label">Monto global a abonar</label>
                                            <input type="number" min="0" step="0.01" class="form-control text-end"
                                                v-model.number="globalAmount.value" placeholder="0.00" />
                                            <div v-if="globalError" class="text-danger small mt-1">
                                                {{ globalError }}
                                            </div>
                                        </div>
                                    </div>

                                    <small class="text-muted">
                                        Seleccionados: {{ selectedPayments.length }}.
                                        <span v-if="allAbonarSelected">Se utilizará el monto global.</span>
                                        <span v-else-if="selectedPayments.length > 0">Asigna el monto en cada fila
                                            seleccionada.</span>
                                    </small>
                                </div>
                            </div>

                            <hr class="my-4" />

                            <!-- 2) Divisa -->
                            <div class="row">
                                <div class="col-12 col-md-4 mb-3">
                                    <label class="form-label">Fecha del pago</label>
                                    <VueDatePicker v-model="dataForm2.abonoDate.value" locale="es"
                                        :enable-time-picker="false" format="dd/MM/yyyy" cancel-text="Cancelar"
                                        select-text="Seleccionar" :teleport="true" />
                                    <span v-if="dataForm2.abonoDate.err" class="text-danger">Debe escoger una
                                        fecha</span>
                                </div>
                                <div class="col-4 mb-4">
                                    <label for="currenci" class="form-label">Divisa</label>
                                    <select class="form-select" aria-label="Default select example"
                                        v-model="dataForm2.currenci.value"
                                        @change="formatAmountAndUpdate(dataForm2.mount, dataForm2.currenci)">
                                        <option v-for="currenci in currencies" :key="currenci.id_currency"
                                            :value="currenci.id_currency">
                                            {{ currenci.name }}
                                        </option>
                                    </select>
                                </div>

                            </div>
                            <p>En caso de abonar en moneda distinta a la del pago a proveedor original, llenar:</p>
                            <div class="row">
                                <div class="row">
                                    <div class="col-md-3 mb-4">
                                        <label class="form-label">Tasa de cambio</label>
                                        <input type="number" min="0" step="0.0001" class="form-control"
                                            v-model.number="dataForm2.exchangeRate.value">
                                        <span v-if="dataForm2.exchangeRate.err" class="text-danger">Debe ingresar una
                                            tasa
                                            válida</span>
                                    </div>

                                </div>
                            </div>
                            <div class="row">
                                <div class="col-6 mb-4">
                                    <button class="btn btn-secondary dropdown-toggle" type="button"
                                        data-bs-toggle="dropdown" aria-expanded="false" @click="toggleDolarTabla2()">
                                        Ver tasas de cambio (dólar)
                                    </button>
                                </div>
                            </div>

                            <div class="row" v-if="showDolarTable2">
                                <div class="col-6 mb-4">
                                    <vue3-datatable :search="search" :rows="exchangeDollar" :columns="columns3" order
                                        :sortable="true">

                                        <template #year="data">
                                            <span>{{ data.value.year }}</span>
                                        </template>
                                        <template #month="data">
                                            <span>{{ data.value.month }}</span>
                                        </template>
                                        <template #dollar_value="data">
                                            <span>{{ data.value.dollar_value }}</span>
                                        </template>
                                    </vue3-datatable>
                                </div>
                            </div>
                            <!-- 3) Nueva cuenta bancaria (opcional) -->
                            <div class="row ">
                                <div class="col-12 mb-2">
                                    <div class="form-check">
                                        <input class="form-check-input" type="checkbox" id="chkNewBank"
                                            v-model="newBank">
                                        <label class="form-check-label" for="chkNewBank">Ingresar una cuenta
                                            bancaria</label>
                                    </div>
                                </div>
                            </div>

                            <div class="row pt-2 px-1 " v-if="newBank">
                                <h6 class="text-black">Ingrese una cuenta bancaria</h6>
                                <div class="col-4 mb-4">
                                    <label class="form-label">Método de pago</label>
                                    <select class="form-select" v-model="dataForm2.paymentMethod.value">
                                        <option :value="0">Sin especificar</option>
                                        <option v-for="pm in paymentMethodes" :key="pm.id" :value="pm.id">
                                            {{ pm.name }}
                                        </option>
                                    </select>
                                </div>
                                <div class="col-4 mb-4">
                                    <label class="form-label">Banco de origen</label>
                                    <select class="form-select" v-model="dataForm2.bank.value">
                                        <option :value="0">Sin especificar</option>
                                        <option v-for="bank in banks" :key="bank.id_bank" :value="bank.id_bank">
                                            {{ bank.name }}
                                        </option>
                                    </select>
                                </div>
                                <div class="col-4 mb-4 ">
                                    <label class="form-label">Cuenta Origen</label>
                                    <input type="text" class="form-control"
                                        :class="{ 'border-danger': dataForm2.accountOrigin.err }"
                                        v-model="dataForm2.accountOrigin.value" placeholder="Ej: 123-456-789" />
                                </div>
                            </div>

                            <!-- 4) Observación -->
                            <div class="row pt-2 px-1">
                                <div class="col-6">
                                    <label class="form-label">Observación</label>
                                    <textarea class="form-control" rows="3"
                                        :class="{ 'border-danger': dataForm2.description.err }"
                                        v-model="dataForm2.description.value"
                                        placeholder="Ingrese un mensaje"></textarea>
                                    <p v-if="dataForm2.description.err" class="text-danger">Debe ingresar una
                                        observación
                                    </p>
                                </div>
                            </div>

                            <!-- 5) Adjuntar documento -->
                            <div class="mt-3">
                                <p>Adjuntar factura o documento que corresponda</p>
                                <div class="row">
                                    <div class="col-4 mb-4">
                                        <label class="form-label">Número comprobante pago</label>
                                        <input type="text" class="form-control"
                                            :class="{ 'border-danger': dataForm2.documentNumber.err }"
                                            v-model="dataForm2.documentNumber.value" placeholder="" />
                                        <span v-if="dataForm2.documentNumber.err" class="text-danger">Debe ingresar un
                                            número de
                                            documento</span>
                                    </div>

                                    <div class="col-6 mb-4 px-4">
                                        <div v-if="dataForm2.fileName == ''">
                                            <label class="form-label mb-0">Adjuntar Documento</label>
                                            <DropFile @drag-end="updateFileBlob" :files="dataForm2.files"
                                                v-if="dataForm2.fileName == ''" />
                                        </div>

                                        <span v-if="dataForm2.filerr" class="text-danger">Debe adjuntar un
                                            documento</span>

                                        <div v-if="dataForm2.fileName != ''">
                                            <label class="form-label mb-0">Documento adjuntado</label>
                                            <div class="text-dark row">
                                                <a class="col-6" :title="dataForm2.fileName">
                                                    {{ dataForm2.fileName.length > 15 ? dataForm2.fileName.substring(0,
            15) +
            "..." : dataForm2.fileName }}
                                                </a>
                                                <div class="col-1" @click="showModal = true">
                                                    <a class="dropdown-item text-primary" href="#"><i
                                                            class="bi bi-eye px-2"></i></a>
                                                </div>
                                                <div class="col-1" @click="deleteArchive()">
                                                    <a class="dropdown-item text-danger" href="#"><i
                                                            class="bi bi-trash px-2"></i></a>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <PreviewFile v-if="showModal" :blob="dataForm2.fileBlob"
                                        :mimeType="dataForm2.mime_type" :visible="showModal"
                                        @close="showModal = false" />
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="modal-footer mt-3">
                        <button type="button" class="btn btn-secondary mx-2"
                            @click="closeAbonarModal()">Cancelar</button>
                        <button type="button" class="btn btn-success" @click="abonarSelected()"
                            :disabled="!canSubmitAbono">Abonar</button>
                    </div>
                </div>
            </div>
        </div>
        <!-- Ver -->
        <div class="modal-mb" v-if="verModal">
            <div class="modal-dialo bg-white">
                <div class="modal-content">
                    <div class="modal-header row">
                        <h5 class="modal-title text-black col-11" id="exampleModalLabel">Nota de cobro</h5>
                        <button type="button" class="btn-close col" data-bs-dismiss="modal" @click="closeModal()"
                            aria-label="Close"></button>
                    </div>
                    <div class="modal-body mt-4">
                        <p class="text-black"
                            v-if="(billNote.id_billing_note_status == 3) || (billNote.id_billing_note_status == 4)">Esta
                            nota de
                            cobro fue emitida</p>
                        <p class="text-black" v-else>Esta nota de cobro no fue emitida</p>
                        <div class="card p-4">
                            <div class="row">
                                <div class="col-md-4">
                                    <b>Identificador</b>
                                    <p>{{ billNote.id_billing_note }}</p>
                                </div>
                                <div class="col-md-4">
                                    <b>Nº nota de cobro</b>
                                    <p>{{ billNote.billing_note_number }}</p>
                                </div>

                                <div class="col-md-4">
                                    <b>Fecha de creación</b>
                                    <p>{{ billNote.created_at }}</p>
                                </div>
                                <div class="col-md-4">
                                    <b>RUT cliente</b>
                                    <p>{{ billNote.rut }}</p>
                                </div>
                                <br>
                                <div class="col-md-4">
                                    <b>Nombre cliente</b>
                                    <p>{{ billNote.name }}</p>
                                </div>
                                <div class="col-md-4">
                                    <b
                                        v-if="(billNote.id_billing_note_status == 3) || (billNote.id_billing_note_status == 4)">Monto
                                        emitido</b>
                                    <b v-else>Monto a emitir</b>
                                    <p>{{ billNote.emit_amount > 0 ? formatCurrency(billNote.emit_amount,
            billNote.initials) : 0
                                        }}</p>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-md-4">
                                    <b>Monto impago total</b>
                                    <p>{{ billNote.saldo > 0 ? formatCurrency(billNote.saldo,
            billNote.initials) : 0
                                        }}</p>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-md-12">
                                    <b>Pagos a proveedor asociados:</b>
                                    <vue3-datatable :noDataContent="'No se encontraron resultados.'" :search="search"
                                        :rows="billNote.pagos" :columns="columnsModal">

                                        <template #amount="data">
                                            <span>{{ data.value.amount > 0 ? formatCurrency(data.value.amount,
                                                data.value.initials) : 0 }}</span>
                                        </template>

                                        <template #unpaid_amount="data">
                                            <span>{{ data.value.unpaid_amount > 0 ?
                                                formatCurrency(data.value.unpaid_amount,
                                                data.value.initials) : 0 }}</span>
                                        </template>

                                    </vue3-datatable>
                                </div>
                            </div>
                        </div>

                    </div>
                    <div class="modal-footer mt-3">
                        <button type="button" class="btn btn-secondary" data-bs-dismiss="modal"
                            @click="closeModal()">Cerrar</button>

                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import VueDatePicker from '@vuepic/vue-datepicker';
import '@vuepic/vue-datepicker/dist/main.css';
import Vue3Datatable from "@bhplugin/vue3-datatable";
import NavBar from './../component/NavBar.vue';
import BarTop from './../component/BarTop.vue';
import DropFile from './../component/DropFile.vue';
import PreviewFile from './../component/PreviewFile.vue';

export default {
    components: {
        VueDatePicker,
        Vue3Datatable,
        NavBar,
        BarTop,
        DropFile,
        PreviewFile,
    },
    data() {
        return {
            loading: false,
            page: 1,
            perPage: 20,
            totalRows: 0,
            sortColumn: 'id_billing_note', // o el campo que prefieras por defecto
            sortDirection: 'desc',
            search: '',
            collapsed: true,
            verModal: false,
            billNote: {},
            pinned: localStorage.getItem('pinned') == 'false' ? false : true || false,
            theme: localStorage.getItem('theme') || 'light-mode',
            options: {
                responsive: true,
                maintainAspectRatio: false,
            },
            items: [

            ],
            amountErrors: false,
            globalError: false,
            // ...
            abonarModal: false,
            abonarNote: null,           // nota actual donde se abona
            selectedPayments: [],       // ids seleccionados
            selectedAmounts: {},        // { [id_payment]: number }
            globalAmount: { value: 0 }, // para "Seleccionar todos"
            abonarProvisionModal: false,
            supply: [],                 // lista de provisiones del cliente
            selectedSupply: null,
            clientName: '',

            supplyColumns: [
                { field: "item", title: "Concepto" },
                { field: "amount", title: "Monto" },
                { field: "actions", title: "" }
            ],

            // para el adjunto
            dataForm2: {
                documentNumber: { value: '', err: false },
                fileName: '',
                mime_type: '',
                files: [],
                fileBlob: null,
                filerr: false,
                exchangeRate: { value: 1, err: false },
                valueMoney: 0,
                abonoDate: { value: new Date(), err: false },
                currenci: { value: 15, err: false }, // id_currency
                mount: { value: 0, value_formated: '', err: false }, // opcional si usas formateo
                paymentMethod: { value: 0, err: false },
                bank: { value: 0, err: false },
                accountOrigin: { value: '', err: false },
                description: { value: '', err: false }
            },
            showModal: false,
            exchangeDollar: 0,
            // sección moneda + banco + observación
            currencies: [],       // cargar por API
            banks: [],            // cargar por API
            newBank: false,
            paymentMethodes: [
                { id: 1, name: 'Transferencia electrónica' },
                { id: 2, name: 'Tarjeta de crédito' },
                { id: 3, name: 'Efectivo' },
            ],
            columns3: [
                { field: "year", title: "Año" },
                { field: "month", title: "Mes" },
                { field: "dollar_value", title: "Valor dólar" },
            ],
            CLP_CURRENCY_ID: 15,
            // ampliamos tu dataForm existente (filtros) con campos del abono:
            emitirModal: false,
            showDolarTable: false,
            showDolarTable2: false,
            emitNote: null,
            date_emit: {
                value: null, // Date | string 'YYYY-MM-DD'
                err: false,
                msjErr: ''
            },
            dataForm: {
                rut: {
                    value: '',
                    err: false,
                    msjErr: ''
                },
                name: {
                    value: '',
                    err: false,
                    msjErr: ''
                },
                billing_note_number: {
                    value: '',
                    err: false,
                    msjErr: ''
                },
                amount: {
                    value: 0,
                    err: false,
                    msjErr: ''
                }
            },
            columns: [
                { field: "id_billing_note", title: "ID" },
                { field: "billing_note_number", title: "Nota de cobro" },
                { field: "emit_date", title: "Fecha emisión" },
                { field: "week_number", title: "Nro. de semana" },
                { field: "status_name", title: "Estado" },
                { field: "created_at", title: "Fecha creación" },
                { field: "rut", title: "Rut cliente" },
                { field: "name", title: "Nombre cliente" },
                { field: "emit_amount", title: "Monto" },
                { field: "saldo", title: "Monto impago" },
                { field: "actions", title: "" }
            ],
            columnsModal: [
                { field: "id_payment", title: "ID" },
                { field: "concept", title: "concepto" },
                { field: "amount", title: "Monto" },
                { field: "unpaid_amount", title: "Monto impago" },
                { field: "initials", title: "moneda" },

            ]
        }
    },
    async mounted() {
        this.getAR()
        document.body.className = this.theme;
        await this.getExchangeDollar();
        this.getCurrencies();
        this.getBanks();
    },
    computed: {
        canSubmitAbonoProvision() {
            const hasDate = !!this.dataForm2.abonoDate.value;
            const hasSupply = !!this.selectedSupply;
            const hasCurrency = !!this.dataForm2.currenci.value;
            const validTC = (this.dataForm2.currenci.value === this.CLP_CURRENCY_ID)
                ? true
                : Number(this.dataForm2.exchangeRate.value) > 0;

            if (!hasDate || !hasSupply || !hasCurrency || !validTC) return false;

            if (this.allAbonarSelected) {
                // Global
                return (Number(this.globalAmount.value) > 0) && !this.globalError;
            }

            // Por filas
            if (!this.selectedPayments.length) return false;
            // manual en CLP
            const hasErr = Object.values(this.amountErrors || {}).some(Boolean);
            const everyPositive = this.selectedPayments.every(id => Number(this.selectedAmounts[id]) > 0);
            return !hasErr && everyPositive;
        },

        allAbonarSelected() {
            const list = this.abonarNote?.pagos || [];
            return list.length > 0 && this.selectedPayments.length === list.length;
        },
        unpaidTotal() {
            // Si tu API ya entrega saldo total en la nota, úsalo.
            return Number(this.abonarNote?.saldo || 0);
        },
        // monto global convertido a CLP
        globalInCLP() {
            const amount = Number(this.globalAmount.value) || 0;
            const rate = (this.dataForm2.currenci.value === this.CLP_CURRENCY_ID)
                ? 1
                : Number(this.dataForm2.exchangeRate.value) || 0;
            return +(amount * rate).toFixed(2);
        },
        // habilita/deshabilita botón ABONAR
        canSubmitAbono() {
            // fecha requerida
            if (!this.dataForm2.abonoDate.value) return false;

            if (this.allAbonarSelected) {
                // Modo global (CASO 1/2)
                if (!(Number(this.globalAmount.value) > 0)) return false;
                if (!this.dataForm2.currenci.value) return false;
                if (this.dataForm2.currenci.value !== this.CLP_CURRENCY_ID &&
                    !(Number(this.dataForm2.exchangeRate.value) > 0)) return false;
                return !this.globalError;
            } else {
                // Modo manual (CASO 3)
                if (!this.selectedPayments.length) return false;
                // todos los seleccionados deben ser válidos y sin error
                return this.selectedPayments.every(id => {
                    const v = Number(this.selectedAmounts[id]) || 0;
                    return v > 0 && !this.amountErrors[id];
                });
            }
        }
    },
    watch: {

        selectedAmounts: {
            deep: true,
            handler() { this.validateRowAmounts(); }
        },
        'globalAmount.value'(nv) { this.validateGlobalAmount(); },
        'dataForm2.currenci.value'(nv) { this.validateGlobalAmount(); },
        'dataForm2.exchangeRate.value'(nv) { this.validateGlobalAmount(); },
    },
    methods: {
        onTableChange(payload) {
            const page = payload.current_page ?? payload.page ?? this.page;
            const perPage = payload.pagesize ?? payload.pageSize ?? this.perPage;
            const sortColumn = payload.sort_column ?? payload.sortColumn ?? this.sortColumn;
            const sortDirection = payload.sort_direction ?? payload.sortDirection ?? this.sortDirection;

            this.page = Number(page) || 1;
            this.perPage = Number(perPage) || this.perPage;
            this.sortColumn = sortColumn || this.sortColumn;
            this.sortDirection = sortDirection || this.sortDirection;

            this.filter();
        },
        async getExchangeDollar() {

            const self = this;

            await axios.get('/api/exchangeDollar', {
                headers: {
                    Authorization: `Bearer ${localStorage.getItem('accessToken')}`
                }
            }).then(response => {

                if (response.status == 200) {
                    self.exchangeDollar = response.data;
                } else {
                    self.exchangeDollar = [];
                }
            }).catch(function (error) {

                if (error.response.statusText == 'Unauthorized') {
                    localStorage.removeItem('accessToken');
                    window.location.href = './../../api/auth/logout'
                } else {

                    self.$swal.fire({
                        icon: "error",
                        title: "Error interno",
                        text: "Comuníquese con soporte.",
                        showConfirmButton: true,
                        showCancelButton: false
                    });
                }
            });
        },
        validateRowAmounts() {
            // Limpia
            this.amountErrors = {};

            const pagos = this.abonarNote?.pagos || [];
            const byId = Object.fromEntries(pagos.map(p => [p.id_payment, p]));
            // Sólo valida cuando NO es “seleccionar todos”
            if (this.allAbonarSelected) return;

            for (const id of this.selectedPayments) {
                const row = byId[id];
                const val = Number(this.selectedAmounts[id] || 0);
                if (!val || val <= 0) {
                    this.$set?.(this.amountErrors, id, 'Debe ser > 0');
                    if (!this.$set) this.amountErrors[id] = 'Debe ser > 0';
                    continue;
                }
                const impago = Number(row?.unpaid_amount || 0);
                if (val > impago) {
                    this.$set?.(this.amountErrors, id, `No puede superar el impago (${this.formatCurrency(impago, row?.initials || 'CLP')})`);
                    if (!this.$set) this.amountErrors[id] = `No puede superar el impago (${this.formatCurrency(impago, row?.initials || 'CLP')})`;
                }
            }
        },

        validateGlobalAmount() {
            this.globalError = '';
            if (!this.allAbonarSelected) return;

            const val = Number(this.globalAmount.value || 0);
            if (!(val > 0)) {
                this.globalError = 'Debe ser > 0';
                return;
            }

            // Comparar contra saldo total en CLP, convirtiendo si corresponde
            const saldoTotalCLP = Number(this.abonarNote?.saldo || 0);
            const isCLP = this.dataForm2.currenci.value === this.CLP_CURRENCY_ID;
            const tc = isCLP ? 1 : Number(this.dataForm2.exchangeRate.value || 0);
            if (!isCLP && !(tc > 0)) {
                this.globalError = 'Tasa de cambio inválida';
                return;
            }
            const valCLP = +(val * tc).toFixed(2);

            if (valCLP > saldoTotalCLP) {
                this.globalError = `No puede superar el impago total (${this.formatCurrency(saldoTotalCLP, 'CLP')})`;
            }
        },
        async openAbonoChoice(note) {
            // guarda la nota
            this.abonarNote = note;
            this.clientName = note?.name || '';
            // Popup de elección
            const res = await this.$swal.fire({
                title: '¿Cómo deseas abonar?',
                text: 'Elige el origen del abono',
                icon: 'question',
                showCancelButton: true,
                showDenyButton: true,
                confirmButtonText: 'Abono normal',
                denyButtonText: 'Abono provisiones',
                cancelButtonText: 'Cancelar'
            });

            if (res.isDismissed) return;
            if (res.isDenied) {
                this.openAbonarProvisionModal(note);
            } else if (res.isConfirmed) {
                this.openAbonarModal(note); // ← tu flujo ya existente
            }
        },

        // 5.2) Abrir modal de provisión
        async openAbonarProvisionModal(note) {
            // limpia estados comunes
            this.selectedSupply = null;
            this.globalAmount.value = 0;
            this.globalError = '';
            this.dataForm2.currenci.value = this.CLP_CURRENCY_ID;
            this.dataForm2.exchangeRate.value = 1;
            console.log(note);
            // trae provisiones del cliente
            await this.getClientSupply(note.id_client);

            this.abonarProvisionModal = true;
        },

        closeAbonarProvisionModal() {
            this.abonarProvisionModal = false;
            this.selectedSupply = null;
            this.supply = [];
        },

        // 5.3) API provisiones
        async getClientSupply(id_client) {
            try {
                const { data } = await axios.get(`/api/clientSupply/${id_client}`, {
                    headers: { Authorization: `Bearer ${localStorage.getItem('accessToken')}` }
                });
                this.supply = Array.isArray(data) ? data : [];
            } catch (e) {
                this.supply = [];
            }
        },

        // 5.4) Seleccionar / deseleccionar una provisión (sólo 1)
        toggleSelectionSupply(row) {
            if (this.isSelectedSupp(row)) {
                this.selectedSupply = null;
            } else {
                console.log(row.currency);
                this.dataForm2.currenci.value = row.currency.id_currency
                this.selectedSupply = row;
            }
        },
        isSelectedSupp(row) {
            return this.selectedSupply && this.selectedSupply.id_clients_supply === row.id_clients_supply;
        },

        // 5.5) Mostrar concepto en tabla supply
        transformItem(item) {
            console.log(item);
            return item.map(concept => concept.concept.name)
                .join(', ');
        },

        // 5.6) Enviar abono desde provisión (GLOBAL auto, Caso 1/2 con supply)
        async abonarDesdeProvision() {
            // Fecha
            const date_payment = this.toISODateOnly(this.dataForm2.abonoDate.value);
            if (!date_payment) {
                this.dataForm2.abonoDate.err = true;
                this.$swal.fire('Atención', 'Debe escoger una fecha válida.', 'info');
                return;
            }
            this.dataForm2.abonoDate.err = false;

            // Provisión
            if (!this.selectedSupply) {
                this.$swal.fire('Atención', 'Debes asociar una provisión.', 'info');
                return;
            }

            // Moneda
            const id_currency_payment = Number(this.dataForm2.currenci.value);
            const isCLP = id_currency_payment === this.CLP_CURRENCY_ID;
            let exchange_rate = this.dataForm2.exchangeRate.value;
            if (!isCLP) {
                const r = Number(this.dataForm2.exchangeRate.value) || 0;
                if (!(r > 0)) {
                    this.$swal.fire('Atención', 'Ingrese una tasa de cambio válida.', 'info');
                    return;
                }
                exchange_rate = String(r);
            }

            // ¿Global o manual?
            const pagos = this.abonarNote?.pagos || [];
            const allSelected = this.allAbonarSelected && pagos.length > 0;

            // payload base
            const base = {
                id_billing_note: this.abonarNote.id_billing_note,
                date_payment,
                id_currency_payment,
                exchange_rate,
                status: 1,
                id_clients_supply: this.selectedSupply.id_clients_supply,
            };

            // === CASO A/B: GLOBAL (todas seleccionadas) ===
            if (allSelected) {
                const value_payment = Number(this.globalAmount.value) || 0;
                if (!(value_payment > 0) || this.globalError) {
                    this.$swal.fire('Atención', this.globalError || 'Monto global inválido.', 'info');
                    return;
                }
                const value_payment_exchanged = isCLP
                    ? value_payment
                    : +(value_payment * Number(exchange_rate)).toFixed(2);

                const payload = {
                    ...base,
                    value_payment,
                    value_payment_exchanged,
                };

                const { isConfirmed } = await this.$swal.fire({
                    title: 'Confirmar abono global',
                    text: `Se abonará globalmente desde provisión #${this.selectedSupply.id_clients_supply}.`,
                    icon: 'question',
                    showCancelButton: true,
                    confirmButtonText: 'Sí, abonar',
                    cancelButtonText: 'Cancelar'
                });
                if (!isConfirmed) return;

                return this._postAbonoProvision(payload);
            }

            // === CASO C: MANUAL POR FILAS (algunas seleccionadas) ===
            // Manual es en CLP (como tu caso 3 de ejemplo)
            if (!this.selectedPayments.length) {
                this.$swal.fire('Atención', 'Debes seleccionar al menos un pago.', 'info');
                return;
            }


            // valida montos por fila
            this.validateRowAmounts();
            if (Object.values(this.amountErrors || {}).some(Boolean)) {
                this.$swal.fire('Atención', 'Corrige los montos con error.', 'info');
                return;
            }

            // arma payment_rows y total
            const rows = [];
            let sum = 0;
            for (const id of this.selectedPayments) {
                const amt = Number(this.selectedAmounts[id] || 0);
                if (!(amt > 0)) {
                    this.$swal.fire('Atención', `Monto inválido en pago #${id}.`, 'info');
                    return;
                }

                sum += isCLP
                    ? amt
                    : +(this.selectedAmounts[id] * Number(exchange_rate)).toFixed(2);;
                rows.push({ [id]: { id_currency: this.dataForm2.currenci.value, amount: amt } });
            }

            const payload = {
                ...base,
                value_payment: sum,
                value_payment_exchanged: sum, // CLP
                payment_rows: rows
            };

            const { isConfirmed } = await this.$swal.fire({
                title: 'Confirmar abono por filas',
                text: `Se abonará manualmente a ${rows.length} pago(s) desde provisión #${this.selectedSupply.id_clients_supply}.`,
                icon: 'question',
                showCancelButton: true,
                confirmButtonText: 'Sí, abonar',
                cancelButtonText: 'Cancelar'
            });
            if (!isConfirmed) return;

            return this._postAbonoProvision(payload);
        },

        async _postAbonoProvision(payload) {
            try {
                this.$swal({ title: 'Procesando abono...', allowOutsideClick: false, didOpen: () => this.$swal.showLoading() });

                const resp = await axios.post('/api/bn-partial-payments', payload, {
                    headers: { Authorization: `Bearer ${localStorage.getItem('accessToken')}` }
                });

                this.$swal.close();

                if (resp.status === 201) {
                    await this.getAR();
                    this.closeAbonarProvisionModal();
                    this.$swal.fire('Éxito', 'Abono desde provisión procesado correctamente.', 'success');
                } else {
                    this.$swal.fire('Error', 'No se pudo procesar el abono.', 'error');
                }
            } catch (err) {
                console.log(err)
                if (err?.response?.statusText === 'Unauthorized') {
                    localStorage.removeItem('accessToken');
                    window.location.href = './../../api/auth/logout';
                    return;
                }
                const msg = err?.response?.data?.message || 'Error inesperado al abonar.';
                this.$swal.fire('Error', msg, 'error');
            }
        },
        openAbonarModal(note) {
            // Si necesitas refrescar pagos, haz GET aquí por id_billing_note y asigna note.pagos
            this.abonarNote = note;
            this.selectedPayments = [];
            this.selectedAmounts = {};
            this.globalAmount.value = 0;
            this.abonarModal = true;
        },

        closeAbonarModal() {
            this.abonarModal = false;
            this.abonarNote = null;
            this.selectedPayments = [];
            this.selectedAmounts = {};
            this.globalAmount.value = 0;

            // limpiar adjunto
            this.dataForm2.documentNumber.value = '';
            this.dataForm2.documentNumber.err = false;
            this.dataForm2.fileName = '';
            this.dataForm2.fileBlob = null;
            this.dataForm2.mime_type = '';
            this.dataForm2.files = [];
            this.dataForm2.filerr = false;

            // limpiar form
            this.dataForm.description.err = false;
        },

        isPaymentSelected(id) {
            return this.selectedPayments.includes(id);
        },
        toggleDolarTabla() {
            this.showDolarTable = !this.showDolarTable;
        },
        toggleDolarTabla2() {
            this.showDolarTable2 = !this.showDolarTable2;
        },
        toggleSelectPayment(pago) {
            const id = pago.id_payment;
            if (this.isPaymentSelected(id)) {
                this.selectedPayments = this.selectedPayments.filter(x => x !== id);
                delete this.selectedAmounts[id];
            } else {
                this.selectedPayments = [...this.selectedPayments, id];
                // valor sugerido: impago
                this.$set?.(this.selectedAmounts, id, Number(pago.unpaid_amount) || 0);
                if (!this.$set) this.selectedAmounts[id] = Number(pago.unpaid_amount) || 0; // por si no estás en Options API con Vue2
            }
        },
        toggleSelectAllAbonar() {
            const list = this.abonarNote?.pagos || [];
            if (this.allAbonarSelected) {
                // deseleccionar todos
                this.selectedPayments = [];
                this.selectedAmounts = {};
                this.globalAmount.value = 0;
            } else {
                // seleccionar todos
                this.selectedPayments = list.map(p => p.id_payment);
                // precargar montos con impago
                const map = {};
                list.forEach(p => { map[p.id_payment] = Number(p.unpaid_amount) || 0; });
                this.selectedAmounts = map;
            }
        },

        /* ——— archivo ——— */
        updateFileBlob() {
            const f = this.dataForm2.files?.[0];
            if (!f) return;
            this.dataForm2.fileName = f.name;
            this.dataForm2.mime_type = f.type;
            this.dataForm2.fileBlob = f;
            this.dataForm2.filerr = false;
        },
        deleteArchive() {
            this.dataForm2.fileName = '';
            this.dataForm2.fileBlob = null;
            this.dataForm2.mime_type = '';
            this.dataForm2.files = [];
            this.dataForm2.filerr = false;
        },

        /* ——— divisas/bancos ——— */
        async getCurrencies() {
            try {
                const { data } = await axios.get('/api/currencies', {
                    headers: { Authorization: `Bearer ${localStorage.getItem('accessToken')}` }
                });
                this.currencies = (data || []).filter(d => d.status == 1);
            } catch (e) { /* noop */ }
        },
        async getBanks() {
            try {
                const { data } = await axios.get('/api/banks', {
                    headers: { Authorization: `Bearer ${localStorage.getItem('accessToken')}` }
                });
                this.banks = data || [];
            } catch (e) { /* noop */ }
        },

        /* ——— opcional: formateo simple de montos ——— */
        formatAmountAndUpdate(amountField, currencyField) {
            // Si ya tienes NumUtils.methods.formatAmountAndUpdate úsalo en lugar de esto
            const raw = String(amountField.value_formated ?? amountField.value ?? '')
                .replace(/[^\d.,-]/g, '')
                .replace(',', '.');
            const num = parseFloat(raw) || 0;
            amountField.value = num;
            amountField.value_formated = new Intl.NumberFormat('es-CL', { minimumFractionDigits: 0 }).format(num);
        },

        /* ——— envío al nuevo endpoint ——— */
        async abonarSelected() {
            // 1) fecha
            const date_payment = this.toISODateOnly(this.dataForm2.abonoDate.value);
            if (!date_payment) {
                this.dataForm2.abonoDate.err = true;
                this.$swal.fire('Atención', 'Debe escoger una fecha válida.', 'info');
                return;
            }
            this.dataForm2.abonoDate.err = false;
            const docNumber = (this.dataForm2.documentNumber?.value || '').trim() || null;
            const description = (this.dataForm2.description?.value || '').trim() || null;
            // 2) arma payload según selección (global = todos / manual = algunas)
            let payload = null;

            if (this.allAbonarSelected) {
                // ===== CASO 1/2: GLOBAL AUTO =====
                const id_currency_payment = Number(this.dataForm2.currenci.value);
                const value_payment = Number(this.globalAmount.value) || 0;

                if (!(value_payment > 0)) {
                    this.$swal.fire('Atención', 'Monto global inválido.', 'info');
                    return;
                }

                // tasa
                let exchange_rate = '1';
                if (id_currency_payment !== this.CLP_CURRENCY_ID) {
                    const r = Number(this.dataForm2.exchangeRate.value) || 0;
                    if (!(r > 0)) {
                        this.$swal.fire('Atención', 'Ingrese una tasa de cambio válida.', 'info');
                        return;
                    }
                    exchange_rate = String(r);
                }

                // monto convertido a CLP
                const value_payment_exchanged = id_currency_payment === this.CLP_CURRENCY_ID
                    ? value_payment
                    : +(value_payment * Number(exchange_rate)).toFixed(2);

                // validación contra impago total
                if (value_payment_exchanged > this.unpaidTotal) {
                    this.$swal.fire(
                        'Atención',
                        `El abono en CLP (${this.formatCurrency(value_payment_exchanged, 'CLP')}) ` +
                        `no puede superar el impago total (${this.formatCurrency(this.unpaidTotal, 'CLP')}).`,
                        'info'
                    );
                    return;
                }

                payload = {
                    id_billing_note: this.abonarNote.id_billing_note,
                    date_payment,
                    value_payment,              // en moneda seleccionada
                    id_currency_payment,        // 15 = CLP (Caso 1), 1=USD (Caso 2) etc.
                    exchange_rate,              // "1" si CLP
                    value_payment_exchanged,    // en CLP
                    status: 1
                };

            } else {
                // ===== CASO 3: MANUAL POR FILA (siempre CLP) =====
                if (!this.selectedPayments.length) {
                    this.$swal.fire('Atención', 'Selecciona al menos un pago.', 'info');
                    return;
                }

                const pagos = this.abonarNote?.pagos || [];
                const byId = Object.fromEntries(pagos.map(p => [p.id_payment, p]));

                const rows = [];
                let sum = 0;

                for (const id of this.selectedPayments) {
                    const p = byId[id];
                    const amt = Number(this.selectedAmounts[id]) || 0;
                    const max = Number(p?.unpaid_amount || 0);

                    if (!(amt > 0)) {
                        this.$swal.fire('Atención', `El monto del pago #${id} debe ser mayor a 0.`, 'info');
                        return;
                    }
                    if (amt > max) {
                        this.$swal.fire('Atención', `El monto del pago #${id} supera su impago.`, 'info');
                        return;
                    }

                    sum += amt;
                    rows.push({ [Number(id)]: { id_currency: this.CLP_CURRENCY_ID, amount: amt } });
                }

                if (sum > this.unpaidTotal) {
                    this.$swal.fire(
                        'Atención',
                        `La suma manual (${this.formatCurrency(sum, 'CLP')}) supera el impago total ` +
                        `(${this.formatCurrency(this.unpaidTotal, 'CLP')}).`,
                        'info'
                    );
                    return;
                }

                payload = {
                    id_billing_note: this.abonarNote.id_billing_note,
                    date_payment,
                    value_payment: sum,                 // CLP
                    id_currency_payment: this.CLP_CURRENCY_ID,
                    exchange_rate: '1',
                    value_payment_exchanged: sum,       // CLP
                    status: 1,
                    payment_rows: rows                  // desglose manual
                };
            }

            // 3) confirmar
            const { isConfirmed } = await this.$swal.fire({
                title: 'Confirmar abono',
                text: this.allAbonarSelected
                    ? `Se abonará globalmente la nota #${this.abonarNote.id_billing_note}.`
                    : `Se abonará manualmente a ${this.selectedPayments.length} pago(s).`,
                icon: 'question',
                showCancelButton: true,
                confirmButtonText: 'Sí, abonar',
                cancelButtonText: 'Cancelar'
            });
            if (!isConfirmed) return;

            // 4) POST (JSON simple)
            try {
                this.$swal({
                    title: 'Procesando abono...',
                    allowOutsideClick: false,
                    didOpen: () => this.$swal.showLoading()
                });

                // --- construir FormData desde el payload existente ---
                const fd = new FormData();

                // 4.1. payload base (global o manual)
                Object.entries(payload).forEach(([k, v]) => {
                    if (v === undefined || v === null) return;
                    if (k === 'payment_rows') {
                        // el backend espera array; con multipart se suele mandar como string
                        fd.append(k, JSON.stringify(v));
                    } else {
                        fd.append(k, v);
                    }
                });

                // 4.2. campos opcionales (solo abono normal)
                if (docNumber) fd.append('doc_number', docNumber);
                if (description) fd.append('description', description);

                if (this.newBank) {
                    const pm = this.dataForm2.paymentMethod?.value ?? 0;  // string|max:128, puedes mandar ID como string
                    const idb = Number(this.dataForm2.bank?.value) || 0;   // exists:banks,id_bank
                    const acc = (this.dataForm2.accountOrigin?.value || '').trim();

                    if (pm) fd.append('payment_method', String(pm));
                    if (idb > 0) fd.append('id_bank', String(idb));
                    if (acc) fd.append('bank_account_origin', acc);
                }

                // 4.3. archivo (si adjuntaste algo)
                if (this.dataForm2?.files && this.dataForm2.files.length > 0) {
                    // DropFile dejó un File nativo
                    fd.append('file', this.dataForm2.files[0]);
                } else if (this.dataForm2?.fileBlob) {
                    // Tienes blob + mime + nombre
                    const mime = this.dataForm2.mime_type || 'application/octet-stream';
                    const name = this.dataForm2.fileName || 'adjunto.bin';
                    const blob = new Blob([this.dataForm2.fileBlob], { type: mime });
                    fd.append('file', blob, name);
                }
                // (si no hay archivo, no se envía "file"; el backend ya maneja sometimes|nullable)

                const resp = await axios.post('/api/bn-partial-payments', fd, {
                    headers: { Authorization: `Bearer ${localStorage.getItem('accessToken')}` }
                    // no seteés Content-Type; axios pone multipart boundary automáticamente
                });

                this.$swal.close();

                if (resp.status === 201) {
                    await this.getAR();
                    this.closeAbonarModal();
                    this.$swal.fire('Éxito', 'Abono procesado correctamente.', 'success');
                } else {
                    this.$swal.fire('Error', 'No se pudo procesar el abono.', 'error');
                }
            } catch (err) {
                console.log(err)
                if (err?.response?.statusText === 'Unauthorized') {
                    localStorage.removeItem('accessToken');
                    window.location.href = './../../api/auth/logout';
                    return;
                }
                const msg = err?.response?.data?.message || 'Error inesperado al abonar.';
                this.$swal.fire('Error', msg, 'error');
            }
        },


        editService(data) {
            window.location.href = '/pagoProveedores/crear/' + data.id_payment;
        },
        addPartialPayment(data) {
            this.$swal({
                title: "¿Deseas abonar este pago?",
                text: "Se redireccionara a la vista de pagos a provedores abonar",
                showDenyButton: true,
                showCancelButton: true,
                showConfirmButton: true,
                confirmButtonText: "Abonar",
                cancelButtonText: 'Cancelar',
                denyButtonText: `Abonar desde provisiones`
            }).then((result) => {
                /* Read more about isConfirmed, isDenied below */
                if (result.isConfirmed) {
                    window.location.href = 'pagoProveedores/abonar/' + data.id_payment + '/' + data.id_client;
                } else if (result.isDenied) {

                    this.getSupply(data, 1)
                }
            });

        },
        async getSupply(data) {
            console.log(data);
            const self = this;
            try {
                const response = await axios.get('/api/clientSupply/' + data.id_client, {
                    headers: {
                        Authorization: `Bearer ${localStorage.getItem('accessToken')}`
                    }
                });
                let supply = response.data; // Array de objetos con el campo "amount"

                // Suma de todos los amounts (asegurándonos de que sean numéricos)
                let totalAmount = supply.reduce((acc, item) => {
                    return acc + Number(item.amount);
                }, 0);

                if (totalAmount > 0) {
                    // Redirige si la suma es mayor que 0
                    window.location.href = 'pagoProveedores/provisionabonar/' + data.id_payment + '/' + data.id_client;
                } else {
                    // Muestra mensaje si no hay saldo
                    this.$swal.fire({
                        icon: 'info',
                        title: 'Sin saldo disponible',
                        text: 'No cuentas con saldo en tus provisiones',
                        confirmButtonText: 'OK'
                    });
                }

            } catch (error) {
                console.error('Error fetching supply:', error);
            }
        },
        edit(id) {
            window.location.href = '/notascobro/edit/' + id;
        },
        filter() {
            this.loading = true;

            const params = {
                page: this.page,
                per_page: this.perPage,
                rut: this.dataForm.rut.value,
                name: this.dataForm.name.value,
                billing_note_number: this.dataForm.billing_note_number.value,
                amount: this.dataForm.amount.value,
                sort_by: this.sortColumn,     // opcional
                sort_dir: this.sortDirection  // opcional
            };

            axios.post('/api/getBillingNotes', params, {
                headers: { Authorization: `Bearer ${localStorage.getItem('accessToken')}` }
            }).then(({ data, status }) => {
                if (status === 200) {
                    this.items = data.data || [];
                    this.totalRows = Number(data.total ?? 0);

                    if (data.per_page) this.perPage = Number(data.per_page);
                    if (data.current_page) this.page = Number(data.current_page);
                } else {
                    this.items = [];
                    this.totalRows = 0;
                }
            }).catch(err => {
                if (err.response?.statusText === 'Unauthorized') {
                    localStorage.removeItem('accessToken');
                    window.location.href = './../../api/auth/logout';
                }
            }).finally(() => {
                this.loading = false;
                this.$swal.close?.();
            });
        },
        closeModal() {
            this.verModal = false;
        },
        emitBill(data) {
            // Abre el modal y guarda la nota seleccionada
            this.emitNote = data;
            this.date_emit.value = null;
            this.date_emit.err = false;
            this.emitirModal = true;
        },

        closeEmitModal() {
            this.emitirModal = false;
            this.emitNote = null;
            this.date_emit.value = null;
            this.date_emit.err = false;
        },

        // Formatea Date -> 'YYYY-MM-DD'
        toISODateOnly(d) {
            if (!d) return null;
            // Si es string, intenta normalizar
            if (typeof d === 'string') {
                // ya viene en 'YYYY-MM-DD'
                if (/^\d{4}-\d{2}-\d{2}$/.test(d)) return d;
                // intentar parsear
                const parsed = new Date(d);
                if (!isNaN(parsed)) return parsed.toISOString().slice(0, 10);
                return null;
            }
            // Date
            try {
                return d.toISOString().slice(0, 10);
            } catch {
                return null;
            }
        },

        async confirmEmit() {
            // Validación simple
            if (!this.date_emit.value) {
                this.date_emit.err = true;
                return;
            }
            this.date_emit.err = false;

            const fechaISO = this.toISODateOnly(this.date_emit.value);
            if (!fechaISO) {
                this.date_emit.err = true;
                this.$swal.fire('Error', 'Fecha inválida', 'error');
                return;
            }

            // Confirmación
            const { isConfirmed } = await this.$swal.fire({
                title: 'Confirmar emisión',
                text: `¿Desea emitir la boleta con fecha ${fechaISO}?`,
                icon: 'question',
                showCancelButton: true,
                confirmButtonText: 'Sí, emitir',
                cancelButtonText: 'Cancelar'
            });
            if (!isConfirmed) return;

            // Llamada al endpoint
            this.$swal({
                title: 'Emitiendo boleta...',
                allowOutsideClick: false,
                didOpen: () => { this.$swal.showLoading(); }
            });

            try {
                const payload = {
                    id_billing_note: this.emitNote.id_billing_note,
                    date_emit: fechaISO
                };
                const resp = await axios.post('/api/emitNote', payload, {
                    headers: {
                        Authorization: `Bearer ${localStorage.getItem('accessToken')}`
                    }
                });

                if (resp.status === 200) {
                    this.$swal.close();
                    await this.filter(); // o this.getAR() si prefieres refrescar todo
                    this.$swal.fire('Éxito', 'Boleta emitida correctamente', 'success');
                    this.closeEmitModal();
                } else {
                    this.$swal.fire('Error', 'No se pudo emitir la boleta', 'error');
                }
            } catch (err) {
                // Manejo de 401 como en tus otros métodos
                if (err?.response?.statusText === 'Unauthorized') {
                    localStorage.removeItem('accessToken');
                    window.location.href = './../../api/auth/logout';
                    return;
                }
                const msg = err?.response?.data?.message || 'Error inesperado al emitir.';
                this.$swal.fire('Error', msg, 'error');
            }
        },
        formatCurrency(value, currencyCode = 'CLP') {

            return new Intl.NumberFormat('es-CL', {
                style: 'currency',
                currency: currencyCode,
                minimumFractionDigits: 0 // O puedes cambiar el valor según lo que necesites
            }).format(value);
        },
        updateCollapsed(value) {

            this.collapsed = value; // Actualiza el estado
        },
        updatePinned(value) {

            this.pinned = value; // Actualiza el estado
        },
        showBill(data) {
            this.verModal = true;
            this.billNote = data;
        },
        getAR() {
            this.$swal({ title: 'Obteniendo notas de cobro' });
            this.$swal.showLoading();
            this.loading = true;

            const params = {
                page: this.page,
                per_page: this.perPage,
                rut: this.dataForm.rut.value,
                name: this.dataForm.name.value,
                billing_note_number: this.dataForm.billing_note_number.value,
                amount: this.dataForm.amount.value,
                sort_by: this.sortColumn,      // si tu backend lo soporta (opcional)
                sort_dir: this.sortDirection   // idem
            };

            axios.post('/api/getBillingNotes', params, {
                headers: { Authorization: `Bearer ${localStorage.getItem('accessToken')}` }
            }).then(({ data, status }) => {
                if (status === 200) {
                    this.items = data.data || [];
                    this.totalRows = Number(data.total ?? 0);

                    if (data.per_page) this.perPage = Number(data.per_page);
                    if (data.current_page) this.page = Number(data.current_page);
                } else {
                    this.items = [];
                    this.totalRows = 0;
                }
            }).catch(err => {
                if (err.response?.statusText === 'Unauthorized') {
                    localStorage.removeItem('accessToken');
                    window.location.href = './../../api/auth/logout';
                }
            }).finally(() => {
                this.loading = false;
                this.$swal.close?.();
            });
        },

        /* formatea mientras escribe y sólo agrega el guion final */
        handleRutInput(e) {
            // 1. quitar caracteres no permitidos y pasar a mayúsculas
            const raw = e.target.value.replace(/[^0-9kK]/g, '').toUpperCase();

            // 2. si aún no hay suficiente largo, mostrar tal cual
            if (raw.length <= 1) {
                this.dataForm.rut.value = raw;
                this.dataForm.rut.err = false;
                return;
            }

            // 3. separar cuerpo y dígito verificador
            const cuerpo = raw.slice(0, -1);
            const dv = raw.slice(-1);

            // 4. concatenar con guion (sin puntos)
            this.dataForm.rut.value = `${cuerpo}-${dv}`;
            this.dataForm.rut.err = false;   // limpia error mientras escribe
        },

        async deleteFilters() {

            document.getElementById("name").value = "";
            this.dataForm.name.value = "";

            document.getElementById("billing_note_number").value = "";
            this.dataForm.billing_note_number.value = "";

            document.getElementById("rut").value = "";
            this.dataForm.rut.value = "";

            document.getElementById("amount").value = "0";
            this.dataForm.amount.value = "0";

            this.filter();

        }
    },
};
</script>

<style lang="css">
@import 'bootstrap';
@import 'datatables.net-bs5';

body {
    background-color: #f2f5f9;
}

.cont-proveedor {
    height: 300px;
    overflow-y: scroll;
}
</style>